$(document).ready(function () {
    const $html = $('html');
    const $body = $('body');
    const $header = $('#top');
    const $h_height = $header.innerHeight();

    //Hamburger
    let $button_close = $('#navbar-custom-toggler');

    if ($button_close.length > 0) {
        $button_close.on('click', function () {
            let $this = $(this);


            if (!$this.hasClass('is-active')) {
                $this.addClass('is-active');

                if ($(window).width() < 1200) {
                    $body.addClass('menu-open');
                    $html.addClass('menu-open');
                }
            } else {
                $this.removeClass('is-active');
                $body.removeClass('menu-open');
                $html.removeClass('menu-open');
            }
        });
    }

    //Sticky on mouse scroll
    if ($header.length > 0) {
        let position = $header.offset().top + $h_height + 32;

        if (window.pageYOffset >= position) {
            $header.addClass('sticky');
            $html.addClass('sticky');
            $body.css('margin-top', $h_height);
        }

        $(window).scroll(function () {
            if ($(document).scrollTop() > position) {
                $header.addClass('sticky');
                $html.addClass('sticky');
                $body.css('margin-top', $h_height);
            } else {
                $header.removeClass('sticky');
                $html.removeClass('sticky');
                $body.css('margin-top', 0);
            }
        });
    }

    if (window.innerWidth > 1199) {
        document.querySelectorAll('.navbar-nav-list .nav-item').forEach(function (everyitem) {
            everyitem.addEventListener('mouseover', function (e) {
                let el_link = this.querySelector('a.dropdown-toggle');

                if (el_link != null) {
                    let nextEl = el_link.nextElementSibling;
                    el_link.classList.add('show');
                    nextEl.classList.add('show');
                }
            });

            everyitem.addEventListener('mouseleave', function (e) {
                let el_link = this.querySelector('a.dropdown-toggle');

                if (el_link != null) {
                    let nextEl = el_link.nextElementSibling;
                    el_link.classList.remove('show');
                    nextEl.classList.remove('show');
                }
            })
        });
    }

    if (window.innerWidth < 1199) {
        let $lang_selector = $('.language-selector .lang-selector');

        $lang_selector.on('click', function (e) {
            console.log('Lang')
            e.preventDefault();
            $(this).siblings('.language-dropdown').toggleClass('show')
        })
    }
});
